<template>
    <v-container class="profile-view-container">
        <v-row justify="center">
            <v-col cols="12">
                <v-card flat color="transparent" class="mb-14">
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" class="pa-1">
                                <v-card color="secondary" flat class="mb-4" style="border-radius: 10px;">
                                    <v-card-text>
                                        <v-list class="pa-0" color="transparent">
                                            <v-list-item class="pa-0 profile-summary-item" three-line>
                                                <v-list-item-avatar class="my-0 align-self-center" size="80" style="border: 1px solid #0D93A5">
                                                    <img :src="'/' + ( user.photo ? user.photo : 'img/photo-default.jpg' )" :alt="displayName"/>
                                                </v-list-item-avatar>
                                                <v-list-item-content class="pa-0 align-self-center">
                                                    <v-list-item-title class="font-weight-bold mb-1 text-sm-h6 text-lg-h5 primary--text">
                                                        {{ displayName }}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle class="font-weight-bold mb-1 primary--text">
                                                        {{ accountTag }}
                                                    </v-list-item-subtitle>
                                                    <v-list-item-content
                                                        :class="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary'))) + '--text d-inline-block py-0 font-weight-bold mb-1'">
                                                        {{ user.status === 103 ? 'Verificado' : (user.status === 102 ? 'En Revisión' : (user.status === 104 ? 'Bloqueado' : 'Sin Verificar')) }}
                                                        <v-icon small :color="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary')))">
                                                            {{ 'mdi-' + (user.status === 103 ? 'check' : (user.status === 102 ? 'sync' : (user.status === 104 ? 'close' : 'alert'))) + '-circle' }}
                                                        </v-icon>
                                                    </v-list-item-content>
                                                    <v-list-item-subtitle class="font-weight-bold mb-1 primary--text">
                                                        IP: {{ user.ip }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action class="profile-summary-action my-0 ml-2">
                                                    <v-btn x-large depressed color="primary secondary--text" fab @click="view = true">
                                                        <v-icon large>mdi-qrcode-scan</v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <template v-for="item in actions">
                                <v-col cols="6" md="4" lg="3" class="pa-1">
                                    <v-card dark flat color="primary" class="profile-action-card px-0 text-center" :to="'/user/' + item.link">
                                        <v-icon color="secondary" class="pt-3" size="42">{{ item.icon }}</v-icon>
                                        <v-card-subtitle class="px-0 py-1 d-block secondary--text">{{ item.name }}</v-card-subtitle>
                                    </v-card>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-footer fixed tile padless class="text-center mb-14">
            <v-row class="mx-0" justify="center" align="center">
                <v-col cols="12" md="10" lg="8">
                    <v-btn block depressed @click="logout()" color="error" large style="display:inline-grid;white-space:normal;">
                        <v-icon class="pr-2">mdi-logout</v-icon> Cerrar Sesión
                    </v-btn>
                </v-col>
            </v-row>
        </v-footer>
        <v-dialog
            v-model="view"
            scrollable
            transition="dialog-bottom-transition"
            max-width="520px"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            :hide-overlay="$vuetify.breakpoint.xsOnly">
            <v-card class="profile-fixed-dialog profile-qr-dialog">
                <v-card-title class="primary secondary--text profile-fixed-header">
                    <v-spacer/>
                    Mi QR
                    <v-spacer/>
                    <v-icon class="align-end" color="secondary" large @click="view = false">mdi-close-circle</v-icon>
                </v-card-title>
                <v-card-text class="profile-fixed-body text-center pa-5">
                    <div class="receive-qr-card mx-auto pa-5">
                        <h2 class="primary--text font-weight-bold mb-1">Escanea y paga</h2>
                        <div class="body-2 grey--text text--darken-1 mb-4">Paga directo con Valzum</div>
                        <div class="receive-qr-box mx-auto">
                            <vue-qrcode :value="accountTag" :scale="9" :margin="1" :version="3"/>
                            <img class="valzum-qr-center-logo" src="/img/favicon.png" alt="Valzum">
                        </div>
                        <div class="text-h5 primary--text font-weight-bold mt-4">{{ accountTag }}</div>
                    </div>
                </v-card-text>
                <v-card-actions class="profile-fixed-footer px-5 pb-5">
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-btn
                                block
                                color="primary"
                                text
                                v-clipboard:copy="accountTag"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">
                                <v-icon left>mdi-content-copy</v-icon> Copiar
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-btn block color="primary" depressed class="secondary--text" @click="downloadReceiveQr">
                                <v-icon left>mdi-download</v-icon> Descargar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import VueQrcode from 'vue-qrcode';
import QRCode from 'qrcode';

export default {
    name: "ProfileView",
    props: ['user'],
    components: { VueQrcode },
    data: () => ({
        loading: true,
        actions: [
            {name: "Mis Datos", icon: "mdi-account-details", link: "edit"},
            {name: "Config. y Seguridad", icon: "mdi-shield-key", link: "settings"},
            {name: "Mis Cuentas", icon: "mdi-account-cash", link: "accounts"},
            {name: "Correcciones", icon: "mdi-receipt-text-edit", link: "corrections"},
            {name: "Información", icon: "mdi-information", link: "about"},
            {name: "Recompensas", icon: "mdi-hand-coin", link: "rewards"},
            {name: "Soporte", icon: "mdi-face-agent", link: "support"},
            {name: "Térm. & Cond.", icon: "mdi-script-text", link: "legal"},
        ],
        view: false
    }),
    computed: {
        accountTag() {
            return '$' + (this.user.nickname || (this.user.id ? String(this.user.id).padStart(5, '0') : ''));
        },
        receiveNickname() {
            return String(this.accountTag || '').trim().replace(/^\$/, '').toUpperCase();
        },
        displayName() {
            return [this.user.name, this.user.lname].filter(Boolean).join(' ').trim();
        }
    },
    methods: {
        async logout() {
            await this.$store.dispatch("logout");
            this.$toast.info('Has cerrado sesion correctamente.', {icon: 'mdi-information'});
            await this.$router.push({name: "Login"});
        },
        onCopy() {
            this.$toast.success('Se copió en el portapapeles.', {icon: 'mdi-content-copy'});
        },
        onError() {
            this.$toast.error('No se copió en el portapapeles.', {icon: 'mdi-content-copy'});
        },
        async downloadReceiveQr() {
            try {
                const primary = '#0D93A5';
                const secondary = '#DFF1F7';
                const dark = '#12343B';
                const canvas = document.createElement('canvas');
                const width = 1200;
                const height = 1600;
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, width, height);

                ctx.fillStyle = primary;
                this.drawRoundRect(ctx, 80, 80, width - 160, height - 160, 42);

                ctx.fillStyle = '#FFFFFF';
                this.drawRoundRect(ctx, 130, 290, width - 260, 900, 36);

                ctx.textAlign = 'center';
                ctx.fillStyle = secondary;
                ctx.font = '700 76px Arial';
                ctx.fillText('VALZUM', width / 2, 205);
                ctx.font = '500 34px Arial';
                ctx.fillText('Wallet para pagos y remesas', width / 2, 255);

                ctx.fillStyle = primary;
                ctx.font = '700 68px Arial';
                ctx.fillText('Escanea y paga', width / 2, 395);
                ctx.fillStyle = dark;
                ctx.font = '400 36px Arial';
                ctx.fillText('Paga directo con Valzum', width / 2, 455);

                const qrCanvas = document.createElement('canvas');
                await QRCode.toCanvas(qrCanvas, this.accountTag, {
                    width: 700,
                    margin: 2,
                    color: {
                        dark: primary,
                        light: '#FFFFFF'
                    }
                });

                const qrX = (width - qrCanvas.width) / 2;
                ctx.drawImage(qrCanvas, qrX, 520);
                await this.drawQrCenterImage(ctx, '/img/favicon.png', width / 2, 520 + (qrCanvas.height / 2), 128);

                ctx.fillStyle = primary;
                ctx.font = '700 74px Arial';
                ctx.fillText(this.accountTag, width / 2, 1285);

                ctx.fillStyle = secondary;
                this.drawRoundRect(ctx, 240, 1380, width - 480, 82, 41);
                ctx.fillStyle = primary;
                ctx.font = '700 34px Arial';
                ctx.fillText('valzum.com', width / 2, 1434);

                const link = document.createElement('a');
                link.download = 'valzum-' + this.receiveNickname.toLowerCase() + '-qr.png';
                link.href = canvas.toDataURL('image/png');
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                this.$toast.error('No fue posible descargar el QR.', {icon: 'mdi-alert-circle'});
            }
        },
        drawRoundRect(ctx, x, y, width, height, radius) {
            const r = Math.min(radius, width / 2, height / 2);

            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + width, y, x + width, y + height, r);
            ctx.arcTo(x + width, y + height, x, y + height, r);
            ctx.arcTo(x, y + height, x, y, r);
            ctx.arcTo(x, y, x + width, y, r);
            ctx.closePath();
            ctx.fill();
        },
        loadImage(src) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = () => resolve(image);
                image.onerror = reject;
                image.src = src;
            });
        },
        async drawQrCenterImage(ctx, src, x, y, size) {
            try {
                const image = await this.loadImage(src);
                ctx.fillStyle = '#FFFFFF';
                this.drawRoundRect(ctx, x - (size / 2), y - (size / 2), size, size, size / 2);
                ctx.drawImage(image, x - (size * 0.34), y - (size * 0.34), size * 0.68, size * 0.68);
            } catch (error) {
                // El QR sigue siendo valido aunque no cargue el logo.
            }
        },
    }
}
</script>

<style scoped>
.profile-view-container {
    padding-bottom: 80px;
}

.profile-summary-item {
    align-items: center;
}

.profile-summary-action {
    align-self: center;
}

.profile-action-card {
    min-height: 86px;
}

.receive-qr-card {
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    box-shadow: 0 10px 28px rgba(13, 147, 165, .12);
    color: #12343B;
    max-width: 370px;
}
.receive-qr-box {
    align-items: center;
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    display: inline-flex;
    justify-content: center;
    max-width: 100%;
    padding: 12px;
    position: relative;
}
.valzum-qr-center-logo {
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 999px;
    box-shadow: 0 4px 14px rgba(13, 147, 165, .18);
    height: 54px;
    left: 50%;
    object-fit: contain;
    padding: 7px;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 54px;
}
.profile-fixed-dialog {
    max-height: 90vh;
    display: flex;
    flex-direction: column;
}

.profile-fixed-header,
.profile-fixed-footer {
    flex: 0 0 auto;
}

.profile-fixed-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

@media (max-width: 600px) {
    .profile-qr-dialog {
        border-radius: 0 !important;
        height: 100%;
        max-height: 100vh;
    }

    .profile-fixed-body {
        padding: 16px !important;
    }

    .profile-fixed-footer {
        padding: 10px 16px calc(16px + env(safe-area-inset-bottom)) !important;
    }

    .receive-qr-card {
        padding: 16px !important;
    }
}
</style>
